import secureLocalStorage from "react-secure-storage";
import { CustomerStylingModel } from "../../Services/customerStyleService";

const applyCustomerStyling = async () => {
    const storedStyling = secureLocalStorage.getItem("customerStyling");

    if (storedStyling) {
        const parsedStyling = JSON.parse(storedStyling as string) as CustomerStylingModel;
        let myDocStyle = document.documentElement.style;
        myDocStyle.setProperty('--application-background', parsedStyling.applicationBackgroundColor);
        myDocStyle.setProperty('--application-background-image', parsedStyling.applicationBackgroundImage);
        myDocStyle.setProperty('--application_background_color_text', parsedStyling.applicationBackgroundColorText);
        myDocStyle.setProperty('--primary-color', parsedStyling.primaryColor);
        myDocStyle.setProperty('--primary-color-text', parsedStyling.primaryColorText);
        myDocStyle.setProperty('--primary-hover-color', parsedStyling.primaryHoverColor);
        myDocStyle.setProperty('--primary-input-background-color', parsedStyling.primaryInputBackgroundColor);
        myDocStyle.setProperty('--primary-input-text-color', parsedStyling.primaryInputTextColor);
        myDocStyle.setProperty('--secondary-color', parsedStyling.secondaryColor);
        myDocStyle.setProperty('--secondary-color-text', parsedStyling.secondaryColorText);
        myDocStyle.setProperty('--secondary-hover-color', parsedStyling.secondaryHoverColor);
        myDocStyle.setProperty('--secondary-input-background-color', parsedStyling.secondaryInputBackgroundColor);
        myDocStyle.setProperty('--secondary-input-text-color', parsedStyling.secondaryInputTextColor);
        myDocStyle.setProperty('--tertiary-color', parsedStyling.tertiaryColor);
        myDocStyle.setProperty('--tertiary-color-text', parsedStyling.tertiaryColorText);
        myDocStyle.setProperty('--tertiary-hover-color', parsedStyling.tertiaryHoverColor);
        myDocStyle.setProperty('--tertiary-input-background-color', parsedStyling.tertiaryInputBackgroundColor);
        myDocStyle.setProperty('--tertiary-input-text-color', parsedStyling.tertiaryInputTextColor);
    }
};

export default applyCustomerStyling;
